
import React, { useEffect, useState } from 'react';
import { Box, Button, Paper, IconButton, Card, Grid, TextField, Typography, useMediaQuery, Chip, MenuItem, Pagination } from '@mui/material';
import { Search } from '@mui/icons-material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAllFarmerCommitmentsAction } from '../../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import FarmerCommitmentDialogs from './FarmerCommitmentDialogs';



// Strip trailing decimal zeros: "10.00" → "10", "10.50" → "10.5"
const fmt = (v) => (v != null && v !== '' ? String(Number(v)) : '');

function FarmerCommitment() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCommitmentId, setSelectedCommitmentId] = useState(null);
  const [farmerId, setFarmerId] = useState(null);
  const [query, setQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [page, setPage] = useState(1);
  const PAGE_SIZE = 30;
  const isMobile = useMediaQuery('(max-width:600px)');

  console.log("farmerId", farmerId);
  
  const { successData } = useSelector((state) => state.getAllFarmerCommitmentsReducer);

  const commitments = Array.isArray(successData?.data) ? successData.data : [];
  const filteredCommitments = commitments.filter((c) => {
    const q = query.trim().toLowerCase();
    let matches = true;
    if (q) {
      const fields = [
        c?.farmer?.name,
        c?.farmer?.geo_code,
        c?.farmer?.mobile,
        c?.crop?.name,
        c?.variety?.name,
      ]
        .filter(Boolean)
        .map((s) => String(s).toLowerCase());
      matches = fields.some((s) => s.includes(q));
    }
    if (statusFilter && c.status !== statusFilter) return false;
    return matches;
  });

  const totalPages = Math.max(1, Math.ceil(filteredCommitments.length / PAGE_SIZE));
  const pagedCommitments = filteredCommitments.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  // Reset to page 1 when filters change
  useEffect(() => { setPage(1); }, [query, statusFilter]);

  const handleOpen = (id = null) => {
    setSelectedCommitmentId(id);
    setOpenDialog(true);
  };
  const handleClose = () => {
    setOpenDialog(false);
  };

  // Open dialog if navigated from registration with openCommitmentDialog flag
  useEffect(() => {
  if (location.state?.openCommitmentDialog) {
    setOpenDialog(true);
    if (location.state.farmerId) {
      setFarmerId(location.state.farmerId); // set the farmerId
    }
    // Optionally clear the state so it doesn't reopen on refresh
    navigate(location.pathname, { replace: true, state: {} });
  }
}, [location, navigate]);

  useEffect(() => {
    // Build query params and endpoint for status filter
    const params = {};
    let query = 'farmer-commitment';
    if (statusFilter) {
      params.status = statusFilter;
      query = `farmer-commitment?status=${encodeURIComponent(statusFilter)}`;
    }
    // For debugging
    console.log('Query Params sent to backend:', params);
    dispatch(getAllFarmerCommitmentsAction({ params, endPoint: query }));
  }, [dispatch, statusFilter]);

  return (
    <Box sx={{ minHeight: '100vh', p: { xs: 0, md: 1 }, mt: { xs: 10, sm: 0 } }}>
      {/* Top bar with search and buttons */}
      <Typography variant="h6" sx={{ fontWeight: 700, mt: -2, mb: 2 }}>
        Farmer Commitment
      </Typography>
      <Card
        elevation={0}
        sx={{
          p: 2,
          mb: 3,
          bgcolor: '#fff',
          borderRadius: 3,
          border: '1px solid #E0E4EC',
          boxShadow: 'none',
        }}
      >
        <Box
          display="flex"
          flexDirection={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'stretch', md: 'center' }}
          justifyContent="space-between"
          gap={2}
        >
          <Grid item size={{ xs: 12, sm: 8, md: 6 }}>
            <Box display="flex" gap={2}>
              <TextField
                size="small"
                placeholder="Search ..."
                slotProps={{
                  input: {
                    startAdornment: <Search sx={{ mr: 1, color: "text.secondary" }} />,
                  },
                }}
                fullWidth
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 3 } }}
              />
              <TextField
                select
                size="small"
                value={statusFilter}
                onChange={e => setStatusFilter(e.target.value)}
                sx={{ minWidth: 120, '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                label="Status"
                placeholder="Status"
              >
                <MenuItem value="">All Status</MenuItem>
                <MenuItem value="Approved">Purchased</MenuItem>
                <MenuItem value="Pending">Commitment</MenuItem>
                <MenuItem value="Rejected">Rejected</MenuItem>
              </TextField>
            </Box>
          </Grid>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              mt: { xs: 2, md: 0 },
              justifyContent: { xs: 'flex-start', md: 'flex-end' },
            }}
          >
            <Button
              variant="contained"
              sx={{
                background: '#4F46E5',
                borderRadius: 3,
                boxShadow: '0px 4px 16px rgba(5,150,105,0.2)',
                fontWeight: 600,
                textTransform: 'none',
                px: 3,
                py: 1.2,
              }}
              onClick={() => navigate('/SOorMDO/farmerCommitment/postSaleRegister')}
            >
               Sales Register
            </Button>
            <Button
              variant="contained"
              sx={{
                background: '#4F46E5',
                borderRadius: 3,
                boxShadow: '0px 4px 16px #5B5FEF1A',
                fontWeight: 600,
                textTransform: 'none',
                px: 3,
                py: 1.2,
              }}
              onClick={() => navigate('/SOorMDO/farmerCommitment/registerFarmer')}
            >
               Register & Committment
            </Button>
            <Button
              variant="outlined"
              sx={{
                borderRadius: 3,
                background: '#4F46E5',
                fontWeight: 600,
                textTransform: 'none',
                px: 3,
                py: 1.2,
                color: '#fff',
              }}
              onClick={() => { setSelectedCommitmentId(null); setFarmerId(null); setOpenDialog(true); }}
            >
              Add Commitment
            </Button>
          </Box>
        </Box>
      </Card>

      {/* Responsive list: mobile cards (xs) and desktop table */}
      {isMobile ? (
        <Box>
          {pagedCommitments.map((row) => {
            const statusLower = (row?.farmer?.status || '').toLowerCase();
            let chipBg;
            if (statusLower === 'active') {
              chipBg = '#D1FAE5';
            } else if (statusLower === 'pending') {
              chipBg = '#FFEFD6';
            } else {
              chipBg = undefined;
            }
            let chipColor;
            if (statusLower === 'active') {
              chipColor = '#047857';
            } else if (statusLower === 'pending') {
              chipColor = '#B45309';
            } else {
              chipColor = undefined;
            }
            let varietySuffix = '';
            if (row?.variety?.name) {
              varietySuffix = `- ${row?.variety?.name}`;
            }
            let seasonYearSuffix = '';
            if (row?.season?.year) {
              seasonYearSuffix = `(${row?.season?.year})`;
            }
            return (
            <Card key={row.commitment_id} sx={{ mb: 2, borderRadius: 3, p: 2 }}>
              {/* Farmer and Status */}
              <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.5}>
                <Box>
                  <Typography>
                    <span style={{ fontWeight: 600 }}>Farmer:</span> {row?.farmer?.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">{row?.farmer?.geo_code}</Typography>
                </Box>
                <Box display="flex" flexDirection="column" alignItems="flex-end" gap={0.5}>
                  <Chip
                    label={row?.status}
                    sx={{ width: 80, backgroundColor: row.status === 'Approved' ? '#D1FAE5' : row.status === 'Pending' ? '#FFEFD6' : row.status === 'Rejected' ? '#FEE2E2' : undefined,
                      color: row.status === 'Approved' ? '#047857' : row.status === 'Pending' ? '#B45309' : row.status === 'Rejected' ? '#B91C1C' : undefined,
                      fontWeight: 600 }}
                    variant="filled"
                    size="small"
                  />
                </Box>
              </Box>

              {/* Phone */}
              <Box mb={0.5}>
                <Typography variant="body2"><strong>Phone:</strong> {row?.farmer?.mobile}</Typography>
              </Box>
              {/* Agriculture */}
              <Box mb={0.5}>
                <Typography variant="body2"><strong>Agriculture:</strong> {fmt(row?.farmer?.total_acres)} Acres</Typography>
              </Box>
              {/* Crop */}
              <Box mb={0.5}>
                <Typography variant="body2"><strong>Crop:</strong> {row?.crop?.name} {varietySuffix}</Typography>
              </Box>
              {/* Expected Qty */}
              <Box mb={0.5}>
                <Typography variant="body2"><strong>Expected Qty:</strong> {fmt(row?.expected_qty)} {row?.variety?.quantity_type || ''}</Typography>
              </Box>
              {/* Expected Acre */}
              <Box mb={0.5}>
                <Typography variant="body2"><strong>Expected Acre:</strong> {fmt(row?.expected_acre)}</Typography>
              </Box>
              {/* Season */}
              <Box mb={0.5}>
                <Typography variant="body2"><strong>Season:</strong> {row?.season?.name} {seasonYearSuffix}</Typography>
              </Box>

              {/* Actions */}
              <Box display="flex" justifyContent="flex-end" mt={1} gap={0.5}>
                {/* <IconButton size="small" aria-label="view">
                  <VisibilityIcon fontSize="small" sx={{ color: "#046645", filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.25))' }} />
                </IconButton> */}
                <IconButton
                  size="small"
                  aria-label="edit"
                  onClick={() => handleOpen(row.commitment_id)}
                >
                  <EditOutlinedIcon fontSize="small" sx={{ color: "#2563EB", filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.25))' }} />
                </IconButton>
              </Box>
            </Card>
          );
          })}
          {(() => {
            let emptySuffix = '';
            if (query) emptySuffix = ` for "${query}"`;
            return filteredCommitments.length === 0 ? (
              <Typography variant="body2" color="text.secondary" sx={{ px: 1 }}>
                {`No commitments found${emptySuffix}.`}
              </Typography>
            ) : null;
          })()}
          {totalPages > 1 && (
            <Box display="flex" alignItems="center" justifyContent="space-between" mt={2} flexWrap="wrap" gap={1}>
              <Typography variant="body2" >
                Showing {Math.min((page - 1) * PAGE_SIZE + 1, filteredCommitments.length)} to {Math.min(page * PAGE_SIZE, filteredCommitments.length)} of {filteredCommitments.length} entries
              </Typography>
              <Pagination
                count={totalPages}
                page={page}
                onChange={(_, val) => setPage(val)}
                color="primary"
                size="small"
              />
            </Box>
          )}
        </Box>
      ) : (
        <Box>
          {/* Table Header: visible only on sm and up */}
          <Box
            display={{ xs: "none", sm: "grid" }}
            gridTemplateColumns={{ sm: "2fr 2fr 2fr 1fr 1fr 1fr" }}
            px={{ xs: 1, sm: 2 }}
            mb={{ xs: 1, sm: 1 }}
          >
            {[
              "Farmer Identity",
              "Contact & Location",
              "Agricultural Info",
              "Crop",
              "Status",
              "Actions",
            ].map((h) => (
              <Typography key={h} fontSize={{ sm: 12 }} color="#000000" fontWeight={600}>
                {h.toUpperCase()}
              </Typography>
            ))}
          </Box>

          {/* Rows */}
          {pagedCommitments.map((row) => {
            const statusLower = (row?.farmer?.status || '').toLowerCase();
            let chipBg;
            if (statusLower === 'active') {
              chipBg = '#D1FAE5';
            } else if (statusLower === 'pending') {
              chipBg = '#FFEFD6';
            } else {
              chipBg = undefined;
            }
            let chipColor;
            if (statusLower === 'active') {
              chipColor = '#047857';
            } else if (statusLower === 'pending') {
              chipColor = '#B45309';
            } else {
              chipColor = undefined;
            }
            let varietySuffix = '';
            if (row?.variety?.name) {
              varietySuffix = `- ${row?.variety?.name}`;
            }
            return (
            <Paper
              key={row.commitment_id}
              elevation={0}
              sx={{
                mb: { xs: 1, sm: 2 },
                p: { xs: 1, sm: 1.5 },
                borderRadius: 3,
                display: { xs: "block", sm: "grid" },
                gridTemplateColumns: { sm: "2fr 2fr 2fr 1fr 1fr 1fr" },
                alignItems: "center",
                border: "1px solid #E5E7EB",
                gap: { xs: 1, sm: 0 },
                '&:hover': {
                  border: '1.5px solid #2563EB',
                  boxShadow: '0 4px 16px 0 rgba(37,99,235,0.15)',
                },
              }}
            >
              {/* Farmer Identity */}
              <Box display={{ xs: "none", sm: "flex" }} gap={2} alignItems="center">
                <Box>
                  <Typography fontWeight={500} fontSize={{ sm: 16 }}>{row?.farmer?.name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {row?.farmer?.geo_code}
                  </Typography>
                </Box>
              </Box>

              {/* Contact & Location */}
              <Box sx={{ display: { xs: "none", sm: "block" } }}>
                <Typography variant="body2">{row?.farmer?.mobile}</Typography>
              </Box>

              {/* Agricultural Info */}
              <Box sx={{ display: { xs: "none", sm: "block" } }}>
                <Typography fontWeight={600} fontSize={{ sm: 14 }}>
                  {fmt(row?.farmer?.total_acres)} <span style={{ fontWeight: 400 }}>Acres</span>
                </Typography>
                {row?.expected_acre && (
                  <Typography variant="body2" color="text.secondary">Expected: {fmt(row?.expected_acre)} Acres</Typography>
                )}
              </Box>

              {/* Crop */}
              <Box sx={{ display: { xs: "none", sm: "block" } }}>
                <Typography variant="body2">{row?.crop?.name} {varietySuffix}</Typography>
                {row?.expected_qty && (
                  <Typography variant="body2" color="text.secondary">Expected: {fmt(row?.expected_qty)} {row?.variety?.quantity_type || ''}</Typography>
                )}
              </Box>

              {/* Status */}
              <Box sx={{ display: { xs: "none", sm: "flex" }, flexDirection: 'column', gap: 0.5 }}>
                <Chip
                  sx={{ width: 80, backgroundColor: row.status === 'Approved' ? '#D1FAE5' : row.status === 'Pending' ? '#FFEFD6' : row.status === 'Rejected' ? '#FEE2E2' : undefined,
                    color: row.status === 'Approved' ? '#047857' : row.status === 'Pending' ? '#B45309' : row.status === 'Rejected' ? '#B91C1C' : undefined,
                    fontWeight: 600 }}
                  label={row.status}
                  size="small"
                />
              </Box>

              {/* Actions */}
              <Box sx={{ display: { xs: "none", sm: "flex" }, gap: 1, justifyContent: "flex-start" }}>
                {/* <IconButton size="small"
                  onClick={() => navigate('/SOorMDO/farmerCommitment/registerFarmer', { state: { farmerId: row?.farmer_id, mode: 'view' } })}
                >
                  <VisibilityIcon fontSize="small" sx={{ color: "#046645", filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.25))' }} />
                </IconButton> */}
                <IconButton
                  size="small"
                  onClick={() => handleOpen(row.commitment_id)}
                >
                  <EditOutlinedIcon fontSize="small" sx={{ color: "#2563EB", filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.25))' }} />
                </IconButton>
              </Box>
            </Paper>
          );
          })}
          {(() => {
            let emptySuffix = '';
            if (query) emptySuffix = ` for "${query}"`;
            return filteredCommitments.length === 0 ? (
              <Typography variant="body2" color="text.secondary" sx={{ px: 2 }}>
                {`No commitments found${emptySuffix}.`}
              </Typography>
            ) : null;
          })()}
          {totalPages > 1 && (
            <Box display="flex" alignItems="center" justifyContent="space-between" mt={2} flexWrap="wrap" gap={1}>
              <Typography variant="body2" color="black">
                Showing {Math.min((page - 1) * PAGE_SIZE + 1, filteredCommitments.length)} to {Math.min(page * PAGE_SIZE, filteredCommitments.length)} of {filteredCommitments.length} entries
              </Typography>
              <Pagination
                count={totalPages}
                page={page}
                onChange={(_, val) => setPage(val)}
                color="primary"
              />
            </Box>
          )}
        </Box>
      )}

      <FarmerCommitmentDialogs
        open={openDialog}
        onClose={handleClose}
        selectedCommitmentId={selectedCommitmentId}
        farmerId={farmerId}
      />
    </Box>
  );
}

export default FarmerCommitment;